import { API } from 'aws-amplify';
import { DeviceEventKey } from '../model/device-events/device-event';
import { DeviceEventMedia } from '../model/device-events/device-event-media';

export const getDeviceEventLinks = async (key: DeviceEventKey): Promise<DeviceEventMedia[]> =>
  API.post('events', '/events/links', {
    body: key,
  });
